import { useCallback, useEffect, useState } from 'react';
import { throttle } from 'lodash';

import { bindEvent, unbindEvent } from '../../utils/event-utils/event-utils';

export default function useProductComparePreview({
  stickyContainerRef,
  maxProductsForComparison,
  stickyChildRef,
  renderSticky
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  const recalculate = useCallback(() => {
    if (
      !stickyContainerRef.current ||
      !stickyChildRef.current ||
      !renderSticky
    ) {
      return;
    }

    const containerRect = stickyContainerRef.current?.getBoundingClientRect();
    const childRect = stickyChildRef.current?.getBoundingClientRect();

    if (stickyContainerRef.current && stickyChildRef.current) {
      stickyContainerRef.current.style.height = `${childRect?.height}px`;
      stickyChildRef.current.style.width = `${containerRect?.width}px`;
    }

    if (window.innerHeight < containerRect.bottom) {
      stickyChildRef.current.style.position = 'fixed';
      stickyChildRef.current.style.bottom = '0px';
    } else {
      stickyChildRef.current.style.position = 'relative';
    }
  }, [renderSticky, stickyChildRef, stickyContainerRef]);

  useEffect(() => {
    recalculate();
  }, [recalculate]);

  useEffect(() => {
    if (maxProductsForComparison === 2) {
      setIsExpanded(false);
    }
  }, [maxProductsForComparison]);

  useEffect(() => {
    const throttledRecalculate = throttle(recalculate, 20);
    bindEvent(window, ['scroll', 'resize'], throttledRecalculate);
    return () =>
      unbindEvent(window, ['scroll', 'resize'], throttledRecalculate);
  }, [recalculate]);

  return {
    isExpanded,
    recalculate,
    setIsExpanded
  };
}
